import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Guarantee() {
  return <section className="py-10 md:py-20 bg-deepblue-900 text-white relative overflow-hidden" data-id="element-142">
      {/* Decorative background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-aqua-500/10 rounded-full blur-3xl" data-id="element-143"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-144">
        <FadeIn data-id="element-145">
          <div className="inline-flex items-center justify-center w-14 h-14 md:w-24 md:h-24 rounded-full bg-aqua-500/20 text-aqua-400 mb-4 md:mb-8 border-2 border-aqua-400/30" data-id="element-146">
            <ShieldCheck className="w-7 h-7 md:w-12 md:h-12" data-id="element-147" />
          </div>

          <h2 className="text-2xl md:text-5xl font-display font-black mb-3 md:mb-6 text-white" data-id="element-148">
            ✨ GARANTÍA AQUAGYM RESUELTO — 7 DÍAS ✨
          </h2>

          <p className="text-base md:text-2xl text-deepblue-100 leading-relaxed mb-4 md:mb-8" data-id="element-149">
            Abrís los 6 tomos. Revisás los 6 bonos. Los usás en tu clase si
            querés. Si en 7 días no es lo que esperabas:{' '}
            <strong className="text-aqua-300" data-id="element-150">Te devolvemos el 100%.</strong>{' '}
            Sin preguntas. Sin formularios. Sin drama.
          </p>

          <p className="text-sm md:text-lg text-deepblue-200 mb-5 md:mb-10 max-w-2xl mx-auto" data-id="element-151">
            La confianza que tenemos en Aquagym Resuelto™ nos permite hacer esa
            promesa sin dudar. Más de 300 instructores ya lo saben.
          </p>

          <div className="inline-block bg-white/10 backdrop-blur-sm border border-white/20 px-4 py-2 md:px-6 md:py-3 rounded-full font-bold text-aqua-300 tracking-wider uppercase text-xs md:text-base" data-id="element-152">
            TASA DE DEVOLUCIONES MENOR AL 1%
          </div>
        </FadeIn>
      </div>
    </section>;
}